<backbone [currentPage]="'dynamic-pages-list'">
  <header-page-title-box title="Lista de páginas." [links]="[{title: 'Páginas',  link: '/pages'}, {title: 'Lista'}]">
    <div buttons>
      <p-button *showForPermissions="['create_dynamic_pages']" size="small" icon="pi pi-plus" label="Nueva página"
        [routerLink]="['/pages/create']"></p-button>
    </div>
  </header-page-title-box>
  <div class="p-3">
    @if (this.isLoading === true) {
    <section class="page-section bg-white rounded-2 shadow-sm p-3">
      <placeholder-table />
    </section>
    }
    @else {
    <section class="page-section bg-white rounded-2 shadow-sm">
      <table class="table table-responsive-md table-borderless rounded-2 mb-0">
        <thead class="border-bottom">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Página</th>
            <th scope="col">URL</th>
            <th scope="col">Tipo</th>
            <th scope="col">Fecha de creación</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          @for (item of this.pages.content; track $index) {
          <tr>
            <td class="align-middle fw-medium text-muted">
              {{item.page}}
            </td>
            <td class="align-middle fw-medium text-muted">
              {{item.title}}
            </td>
            <td class="align-middle fw-medium text-muted">
              <p-chip label="{{item.url}}" icon="pi pi-link"></p-chip>
            </td>
            <td class="align-middle fw-medium text-muted">
              <span class="d-inline-block text-bg-secondary p-1 px-3 rounded-2">{{item.type}}</span>
            </td>
            <td class="align-middle fw-medium text-muted">
              {{item.dateCreated.ISO8601 | date: 'longDate' }}
            </td>
            <td class="align-middle fw-medium text-nowrap text-end">
              <div class="d-flex justify-content-end gap-1">
                <p-button *showForPermissions="['update_dynamic_pages']" icon="pi pi-eye"
                  [routerLink]="['/pages', item.page]"></p-button>
              </div>
            </td>
          </tr>
          }
          @empty {
          <tr>
            <td scope="row" colspan="6" class="align-middle fw-medium text-center">
              <p class="m-0 p-4 opacity-50">Sin datos</p>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </section>
    }
  </div>
</backbone>